import React from "react";
import MapIcon from "@mui/icons-material/Map";
import { PageHeader, PageShell } from "../../components/UI/Page";

const GrangerYardMap = () => {
  return (
    <PageShell size="xl">
      <PageHeader
        icon={MapIcon}
        tone="slate"
        eyebrow="Admin"
        title="Granger Lumber Yard Map"
      />
      {/* Sample image for now. Kept on a light surface: it's a printed-style
          map drawn on white. */}
      <div className="app-card overflow-hidden rounded-2xl border p-2 sm:p-3">
        <div className="app-light-surface overflow-x-auto rounded-xl bg-white">
          <img
            src={require("../../assets/Granger_Lumber_Yard.png")}
            alt="Granger Lumber yard map"
            className="mx-auto block h-auto w-full max-w-[1100px]"
          />
        </div>
      </div>
    </PageShell>
  );
};

export default GrangerYardMap;
